import { ImageChoiceWUT } from '@wix/form-fields/viewer-wut';

export default ImageChoiceWUT;
